module.exports = __webpack_public_path__ + "img/userRes_b.1dce7fe4.png";